
import styles from './wysiwyg.module.sass'

import BlockWrapper from './layout/block_wrapper'
import ScrollAnimation from './layout/scroll_animation'
import classNames from 'classnames'

function Wysiwyg(props) {
	const fields = props.fields
	const inlineStyles = {maxWidth: fields.max_width ? fields.max_width : null}

	return <BlockWrapper {...props} fullbleed={props.accordionContent ? false : true}>
		<ScrollAnimation styles={styles}>
			{fields && fields.content &&
				<div className={classNames(styles.wysiwyg, props.tabbed_content ? styles.tabbed_content : '')} dangerouslySetInnerHTML={{__html: fields.content}} style={inlineStyles}></div>
			}
		</ScrollAnimation>
	</BlockWrapper>
}

export default Wysiwyg